<template>
  <div class="space-statistics">
    <div class="space-statistics__list">
      <div class="space-statistics__item">
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.77881 9.47119L1.29353 0.98591" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.736 0.986002L1.29355 0.985968L1.29357 6.42886" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.2063 14.7212L1.72102 23.2065" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.72111 17.764L1.72108 23.2064L7.16397 23.2064" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.0288 9.27881L23.5141 0.793527" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M23.514 6.236L23.514 0.793553L18.0711 0.79357" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15.2212 14.7214L23.7065 23.2067" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.264 23.2066L23.7064 23.2067L23.7064 17.7638" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{formattedSurfaceArea}} sqm</span>
      </div>
      <div class="space-statistics__item">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.833374 25H24.8334" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.97327 25L2.03327 10.171C2.03327 9.41907 2.38127 8.70418 2.95727 8.23577L11.3573 1.51772C12.2213 0.827427 13.4333 0.827427 14.3093 1.51772L22.7093 8.22343C23.2973 8.69184 23.6333 9.40674 23.6333 10.171V25" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linejoin="round"/>
        <path d="M17.0334 11.4404H8.63337C7.63737 11.4404 6.83337 12.2663 6.83337 13.2894V24.9998H18.8334V13.2894C18.8334 12.2663 18.0294 11.4404 17.0334 11.4404Z" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.434 17.9119V19.7609" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M11.0334 7.12598H14.6334" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{store_number}} {{$store.getters.language.stores}}</span>
      </div>
      <div class="space-statistics__item">
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0419 3.64727C18.4139 5.87978 18.4139 9.64963 16.0419 11.8821C13.8647 13.9312 10.4686 13.9312 8.2914 11.8821C5.91936 9.64963 5.91936 5.87978 8.2914 3.64727C10.4686 1.59817 13.8647 1.59817 16.0419 3.64727Z" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linejoin="round"/>
        <path d="M0.916626 23.9999L1.16226 22.0348C1.47751 19.5129 3.02806 17.3135 5.29753 16.1692V16.1692C9.61788 13.9909 14.7154 13.9909 19.0357 16.1692V16.1692C21.3052 17.3135 22.8557 19.5129 23.171 22.0348L23.4166 23.9999" stroke="#4D4D4D" stroke-linecap="round"/>
        </svg>
        <span>{{formattedFootfallYearly}} {{$store.getters.language.visitors}}</span>
      </div>
      <div class="space-statistics__item">
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.375 4.125C24.7242 8.47424 24.7242 15.5258 20.375 19.875C16.0258 24.2242 8.97424 24.2242 4.625 19.875C0.275758 15.5258 0.275758 8.47424 4.625 4.125C8.97424 -0.224242 16.0258 -0.224242 20.375 4.125Z" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linejoin="round"/>
        <path d="M12.5001 12V3" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.5 12L17.75 17.25" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{average_length_stay}} {{$store.getters.language.min_visit}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpacesTags',
  props: {
    surface_area: { type: [String, Number], default: null },
    store_number: { type: [String, Number], default: null },
    footfall_yearly: { type: [String, Number], default: null },
    average_length_stay: { type: [String, Number], default: null },
    data: {
      default: null,
      type: Object
    },
    source_type: {
      default: null,
      type: String
    }
  },
  computed: {
    formattedSurfaceArea() {
      return this.surface_area ? this.formatNumberWithCommas(this.surface_area) : null;
    },
    formattedFootfallYearly() {
      if (!this.footfall_yearly) return null;
      const footfall = parseFloat(this.footfall_yearly);
      return footfall >= 1000000
          ? `${(footfall / 1000000).toFixed(1)}M`
          : this.formatNumberWithCommas(footfall);
    }
  },
  methods: {
    formatNumberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.space-statistics {
  width: 100%;
  background: $light-grey;
  color: $primary-grey;
  padding: 32px;
  border-radius: 4px;
}
.space-statistics__list {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.space-statistics__item {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
    @include responsive-text-size('Header--14--REGULAR');

  span {
    width: 100%;
  }
}
</style>
